<template>
  <div>
      {{siteName}} follows the COPE Code of Conduct and Best Practice Guidelines for Journal Editors and the Code of Conduct for Journal Publishers.
      <a href="http://publicationethics.org/resources/code-conduct" target="_blank"> http://publicationethics.org/resources/code-conduct</a>
      <br />
      {{siteName}} follows the COPE general guidelines as well.
      <a href="http://publicationethics.org/resources/guidelines" target="_blank">http://publicationethics.org/resources/guidelines</a>
      <br />
      Also, editors, authors, reviewers should follow the best-practice guidelines on ethical behavior ICMJE’s Recommendations for the Conduct,
      Reporting, Editing and Publication of Scholarly Work in Medical Journals.
      <a href=" http://www.icmje.org/recommendations/" target="_blank"> http://www.icmje.org/recommendations/</a>  In addition, {{siteName}}
      follows the relevant guidelines from Elsevier and its journals.
      <a href="https://www.elsevier.com/editors/publishing-ethics/perk">https://www.elsevier.com/editors/publishing-ethics/perk</a>
  </div>
</template>

<script>
export default {
  name: 'ethics-and-malpractice-content',
  data () {
    return {
      siteName: process.env.SITE_NAME
    }
  }
}
</script>


<style lang="scss" scoped>
  a {
    word-wrap: break-word;
    color: $accent-color-2;
  }
</style>



// WEBPACK FOOTER //
// EthicsAndMalpracticeComponent.vue?61e6e568